<template>

    <Head :title="nx_page.name">
        <meta
            type="title"
            :content="nx_page.seo_meta_title"
            head-key="title"
        >
        <meta
            type="description"
            :content="nx_page.seo_meta_description"
            head-key="description"
        >
        <meta
            type="keywords"
            :content="nx_page.seo_meta_keywords"
            head-key="keywords"
        >
    </Head>

    <div id="wall" class="container-fluid distance-y-container">
        <div class="row padding-y-0-100">
            <div id="wall_inner" class="col-12 col-lg-10 offset-lg-2 px-0 px-sm-3">

                <!-- SPINNER PER CARICAMENTO -->
                <div v-if="authors.length === 0" class="home-spinner-load">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>

                <div class="grid" style="position: relative" ref="masonry">
                    <div class="grid-sizer"></div>
                    <div v-for="(item,index) in authors" class="nx-author grid-item d-flex flex-column">
                        <Link :href="`talenti/${item.slug}`"
                              class="masonry-item-link">

                            <div v-if="item.cover">
                                <div v-if="item.cover.type === 'video'"
                                     :style="{ 'padding-bottom' : ((item.cover.video_data.height / item.cover.video_data.width) * 100) +'%'}"
                                     style="height: 0; position: relative"
                                >
                                    <!-- IN QUESTO PUNTO CI VA IL VIDEO, item.cover.video_url è il link
                                    src="https://player.vimeo.com/video/685828350?h=c81124ab6e"
                                    https://player.vimeo.com/video/685828350?autoplay=1&autopause=0&muted=1&controls=0&loop=1&byline=0&keyboard=0&pip=0&playsinline=1 -->
                                    <span class="visually-hidden" v-text="item.cover.video_url"></span>
                                    <iframe v-if="item.cover.video_data != null" :src="item.cover.video_data.src"
                                            style="position: absolute; top: 0; left: 0;width: 100%;height: 100%;pointer-events: none;user-select: none"
                                            frameborder="0"
                                            class="iframe-video"
                                            width="640"
                                            height="1137"
                                            allow="autoplay"
                                            webkitallowfullscreen
                                            mozallowfullscreen
                                            allowfullscreen></iframe>
                                </div>

                                <figure v-else-if="item.cover.thumbnails" class="mb-0">
                                    <img :src="item.cover.thumbnails['1080p'].url"
                                         :alt="item.cover.alt_text"
                                         :width="item.cover.thumbnails['1080p'].width"
                                         :height="item.cover.thumbnails['1080p'].height">
                                </figure>
                                <figure v-else>
                                    <img src="/client/images/psam-logo-horizontal.png"
                                         :alt="item.name"
                                         class="img-fluid">
                                </figure>
                            </div>

                            <figure v-else>
                                <img src="/client/images/psam-logo-horizontal.png"
                                     :alt="item.name"
                                     class="img-fluid">
                            </figure>
                            <!--
                            <figure v-if="item.cover && item.cover.thumbnails" class="mb-0">
                                <img :src="item.cover.thumbnails['720p'].url"
                                     :alt="item.cover.alt_text"
                                     :width="item.cover.thumbnails['720p'].width"
                                     :height="item.cover.thumbnails['720p'].height">
                            </figure>
                            <figure v-else>
                                <img src="/client/images/psam-logo-horizontal.png"
                                     :alt="item.name"
                                     class="img-fluid">
                            </figure>
                            -->

                        </Link>
                        <div class="nx-content d-flex flex-column align-items-center">
                            <Link :href="`talenti/${item.slug}`"
                                  class="txt-no-underline">
                                    <span
                                        class="text-ellipsis-1l ff-sans fw-500 fz-30 color-black text-uppercase text-center"
                                        v-text="item.name"></span>
                            </Link>
                            <span v-text="item.category"
                                  class="ff-sans fw-300 fz-18 color-black mb-0 text-center"></span>
                        </div>
                    </div>
                </div>
<!--                <MasonryWall v-else :items="authors" :ssr-columns="1" :column-width="columnWidth" :gap="0" class="">
                    <template #default="{item,index}">

                        <div class="nx-author d-flex flex-column">
                            <Link :href="`talenti/${item.slug}`"
                                  class="masonry-item-link">

                                <div v-if="item.cover">
                                    <div v-if="item.cover.type === 'video'"
                                         :style="{ 'padding-bottom' : ((item.cover.video_data.height / item.cover.video_data.width) * 100) +'%'}"
                                         style="height: 0; position: relative"
                                    >
                                        &lt;!&ndash; IN QUESTO PUNTO CI VA IL VIDEO, item.cover.video_url è il link
                                        src="https://player.vimeo.com/video/685828350?h=c81124ab6e"
                                        https://player.vimeo.com/video/685828350?autoplay=1&autopause=0&muted=1&controls=0&loop=1&byline=0&keyboard=0&pip=0&playsinline=1 &ndash;&gt;
                                        <span class="visually-hidden" v-text="item.cover.video_url"></span>
                                        <iframe v-if="item.cover.video_data != null" :src="item.cover.video_data.src"
                                                style="position: absolute; top: 0; left: 0;width: 100%;height: 100%;pointer-events: none;user-select: none"
                                                frameborder="0"
                                                class="iframe-video"
                                                width="640"
                                                height="1137"
                                                allow="autoplay"
                                                webkitallowfullscreen
                                                mozallowfullscreen
                                                allowfullscreen></iframe>
                                    </div>

                                    <figure v-else-if="item.cover.thumbnails" class="mb-0">
                                        <img :src="item.cover.thumbnails['1080p'].url"
                                             :alt="item.cover.alt_text"
                                             :width="item.cover.thumbnails['1080p'].width"
                                             :height="item.cover.thumbnails['1080p'].height">
                                    </figure>
                                    <figure v-else>
                                        <img src="/client/images/psam-logo-horizontal.png"
                                             :alt="item.name"
                                             class="img-fluid">
                                    </figure>
                                </div>

                                <figure v-else>
                                    <img src="/client/images/psam-logo-horizontal.png"
                                         :alt="item.name"
                                         class="img-fluid">
                                </figure>
                                &lt;!&ndash;
                                <figure v-if="item.cover && item.cover.thumbnails" class="mb-0">
                                    <img :src="item.cover.thumbnails['720p'].url"
                                         :alt="item.cover.alt_text"
                                         :width="item.cover.thumbnails['720p'].width"
                                         :height="item.cover.thumbnails['720p'].height">
                                </figure>
                                <figure v-else>
                                    <img src="/client/images/psam-logo-horizontal.png"
                                         :alt="item.name"
                                         class="img-fluid">
                                </figure>
                                &ndash;&gt;

                            </Link>
                            <div class="nx-content d-flex flex-column align-items-center">
                                <Link :href="`talenti/${item.slug}`"
                                      class="txt-no-underline">
                                    <span
                                        class="text-ellipsis-1l ff-sans fw-500 fz-30 color-black text-uppercase text-center"
                                        v-text="item.name"></span>
                                </Link>
                                <span v-text="item.category"
                                      class="ff-sans fw-300 fz-18 color-black mb-0 text-center"></span>
                            </div>
                        </div>
                    </template>

                </MasonryWall>-->


            </div>
        </div>
    </div>


</template>

<script>


import Utils from "../utils/utils";

export default {
    name: "Home",

    props:{
        nx_page: Object,
    },

    data() {
        return {
            authors: [],
            meta: null,
            loading: false,
            breakpoints: {
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200,
                xxl: 1586,
            },
            currentBreakpoint: "sm",
        }
    },

    mounted() {
        const el = document.querySelector("#wall");

        this.scroll();

        if (this.shouldLoadAuthors) {
            this.loadAuthors(this.page);
        }

        const instance = this;

        window.onresize = (e) => {
            const screenSize = Utils.getScreenSize();

            const width = screenSize.w;
            instance.onWindowResized(width);
        };
        this.onWindowResized(Utils.getScreenSize().w);
    },

    updated() {
        //console.log("updated");
        this.masonry();
    },

    methods: {

        masonry() {

            console.log(this.currentBreakpoint);
            console.log(this.columnWidth);

            this._masonry = new Masonry(this.$refs.masonry, {
                itemSelector: ".grid-item",
                columnWidth: ".grid-sizer",
                horizontalOrder: true,
                percentPosition: true
            });
        },

        onWindowResized(width) {
            let detectedBreakpoint = "sm";

            for (const [key, value] of Object.entries(this.breakpoints)) {

                if (width >= value) {
                    detectedBreakpoint = key;
                }
            }

            this.currentBreakpoint = detectedBreakpoint;
        },

        loadAuthors(page) {

            this.loading = true;

            const conf = {
                params: {
                    page: page,
                    thumbnail: ['720p', '1080p'],
                }
            };

            this.axios.get(`${BASE_URL}/api/authors`, conf)
                .then(response => {
                    this.authors = [...this.authors, ...response.data.data];
                    this.meta = response.data.meta;
                }).catch(error => {

            }).finally(() => this.loading = false);


        },

        scroll() {

            window.onscroll = () => {

                const scrollable = document.documentElement.scrollHeight - (Utils.xy().y * 3);
                const scrolled = window.scrollY;

                //console.log([scrollable, scrolled]);

                let bottomOfWindow = false;
                if (Math.ceil(scrolled) >= scrollable) {
                    bottomOfWindow = true;
                }

                if (bottomOfWindow && this.shouldLoadAuthors && !this.loading) {
                    this.loadAuthors(this.page);
                }
            }
        },
    },

    computed: {
        page() {

            if (this.meta == null) {
                return 1;
            } else {
                const current_page = this.meta.current_page;
                const last_page = this.meta.last_page;

                if (current_page < last_page) {
                    return current_page + 1;
                } else {
                    return last_page;
                }
            }
        },

        shouldLoadAuthors() {

            let ret_val = true;

            if (this.meta != null) {
                const current_page = this.meta.current_page;
                const last_page = this.meta.last_page;

                ret_val = current_page < last_page;
            }

            return ret_val;
        },

        columnWidth() {

            let width = 378;

            let wrapper = document.getElementById('wall_inner');
            let wrapperWidth = wrapper.offsetWidth;

            switch (this.currentBreakpoint) {
                case "sm":
                    width = 264.5;
                    break;
                case "md":
                    width = 360.5;
                    break;
                case "lg":
                    width = 391; //395.05
                    break;
                case "xl":
                    width = 430;
                    break;
                case "xxl":
                    width = wrapperWidth / 3.1;
                    break;
            }

            return width;
        }
    },

    watch: {

        currentBreakpoint(newVal, oldVal) {

            //console.log("breakpoint changed: " + oldVal + " -> " + newVal);
        }
    }

}
</script>

<style scoped>

.nx-author {
    overflow: hidden;
    width: 100%;
    background: #F5F5F5;
}

.nx-content {
    padding: 20px;
}

img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    line-height: 0;
    display: block;
}

.grid-item,
.grid-sizer {
    width: calc(100% - 32px);
    margin-bottom: 32px;
    margin-left: 16px;
    margin-right: 16px;
}

@media(min-width: 768px){

    .grid-item,
    .grid-sizer {
        width: calc(50% - 32px);
    }
}

@media(min-width: 1200px){

    .grid-item,
    .grid-sizer {
        width: calc(33.333% - 32px);
    }
}

</style>
